import { defineStore } from 'pinia';
import { ref } from 'vue';

import type {
    PossibleUserPreferences,
    UserErrorData,
    User,
} from '@repository/types';

export const useAuthStore = defineStore('auth', () => {
    const user = ref<User | undefined>(undefined);
    const userPreferences = ref<PossibleUserPreferences>(undefined);
    const showEmailConfirmationPage = ref(false);

    const isUserLoggedIn = computed(() => !!user.value?.id);

    const getUserDetails = async (shouldShowErrors = false) => {
        try {
            const userData = await useNuxtApp().$api.user.getDetails();
            user.value = userData;
            return userData;
        } catch (error) {
            const errors = (error as UserErrorData).data?.errors;
            if (errors && shouldShowErrors) useFetchErrors().showErrors(errors);
            return null;
        }
    };

    const getUserPreferences = async (shouldShowErrors = false) => {
        try {
            const preferencesData =
                await useNuxtApp().$api.user.getPreferences();
            userPreferences.value = preferencesData;
            return preferencesData;
        } catch (error) {
            const errors = (error as UserErrorData).data?.errors;
            if (errors && shouldShowErrors) useFetchErrors().showErrors(errors);
            return null;
        }
    };

    const closeAccount = async (shouldShowErrors = false) => {
        try {
            const response = await useNuxtApp().$api.user.closeAccount();
            if (response === 'ok') user.value = undefined;
            return response;
        } catch (error) {
            const errors = (error as UserErrorData).data?.errors;
            if (errors && shouldShowErrors) useFetchErrors().showErrors(errors);
            return null;
        }
    };

    return {
        user,
        userPreferences,
        isUserLoggedIn,
        showEmailConfirmationPage,
        getUserDetails,
        getUserPreferences,
        closeAccount,
    };
});
